import React, { useState, useEffect } from 'react';

interface SaveButtonProps {
    hasUnsavedChanges: boolean;
    isSaving?: boolean;
    onSave: () => void;
}

const SaveButton: React.FC<SaveButtonProps> = ({ hasUnsavedChanges, onSave }) => {
    const [showSaved, setShowSaved] = useState(false);

    const handleSave = () => {
        onSave();
        setShowSaved(true);
    };

    useEffect(() => {
        if (showSaved) {
            const timer = setTimeout(() => {
                setShowSaved(false);
            }, 2000);

            return () => clearTimeout(timer);
        }
    }, [showSaved]);

    return (
        <div className="pt-6 pb-4 flex justify-center">
            <button
                className={`py-2 px-6 font-semibold text-white rounded-lg transition-colors duration-200 flex items-center justify-center shadow-lg ${
                    showSaved
                    ? 'bg-green-600'
                    : hasUnsavedChanges 
                    ? 'bg-green-600 hover:bg-green-700' 
                    : 'bg-neutral-500 cursor-not-allowed opacity-60'
                }`}
                onClick={handleSave}
                disabled={!hasUnsavedChanges}
            >
                {showSaved ? 'Saved!' : 'Save'}
            </button>
        </div>
    );
};

export default SaveButton;